/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type AuctionLotSecondChanceStatus = "ELIGIBLE" | "INELIGIBLE" | "SENT" | "%future added value";
export type AuctionLotStatus = "CANCELED" | "CLOSED" | "DELETED" | "DRAFT" | "OPEN" | "PAUSED" | "%future added value";
export type useAuctionState_item = {
    readonly isAuctionEnabled: boolean | null;
    readonly relevantAuctionLot: {
        readonly status: AuctionLotStatus | null;
        readonly startDate: string | null;
        readonly endDate: string | null;
        readonly secondChanceOfferSent: boolean | null;
        readonly secondChanceStatus: AuctionLotSecondChanceStatus | null;
    } | null;
    readonly relevantAuctionSolution: {
        readonly reserveMet: boolean | null;
    } | null;
    readonly " $refType": "useAuctionState_item";
};
export type useAuctionState_item$data = useAuctionState_item;
export type useAuctionState_item$key = {
    readonly " $data"?: useAuctionState_item$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"useAuctionState_item">;
};



const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "page",
    "variableName": "page"
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "page"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useAuctionState_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAuctionEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v0/*: any*/),
      "concreteType": "AuctionLot",
      "kind": "LinkedField",
      "name": "relevantAuctionLot",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "secondChanceOfferSent",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "secondChanceStatus",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v0/*: any*/),
      "concreteType": "AuctionSolution",
      "kind": "LinkedField",
      "name": "relevantAuctionSolution",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "reserveMet",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();
(node as any).hash = '321d8c3ccb34a20fae20dec8cab92ff3';
export default node;
